// @ts-nocheck
import _ from "lodash";
import { v4 as uuid } from "uuid";
import FaqBaseObject from "../BaseObjects/Faq.json";

export default {
  computed: {
    faqFormMixin(): any {
      const faqBaseObject = _.cloneDeep(FaqBaseObject);
      faqBaseObject.Elsa.children.generateProjectUUID.children = this.createProjectUUID();
      return faqBaseObject;
    },
    isDisabled() {
      const toDisable = !!_.get(
        this,
        "$store.state.modules.faq.Elsa.generateProjectUUID.project_id",
        ""
      );
      return toDisable;
    },
  },
  methods: {
    createProjectUUID(): any {
      return {
        project_id: {
          type: "string",
          label: "Project ID",
          // disabled: true,
          default: "",
          detail: "WARNING: This will be auto-generated. DO NOT EDIT UNLESS NECESSARY",
        },
        Generate: {
          type: "button",
          buttonType: "danger",
          text: "Generate Project UUID",
          disabled: this.isDisabled,
          onClick: this.generateProjectUUID,
          detail: `Click to set a UUID for project_id 
                  (NOTE: This should only be done once for each project)`,
        },
      };
    },
    generateProjectUUID() {
      const randomUUID = uuid();
      this.$set(this.$store.state.modules.faq.Elsa.generateProjectUUID, "project_id", randomUUID);
    },
  },
};
